<template>
    <footer
        class="footer mt-auto"
        :class="footerClass"
    >
        <div class="container mx-auto py-12">
            <section-text :doc="textDoc" />
        </div>

        <hr />
        <div class="px-5 py-3 container max-w-6xl mx-auto text-left">
            <entries
                :ids="doc.footer_bottom_navigation"
                v-slot="{ entries }"
                class="flex flex-wrap justify-center -m-2"
            >
                <div
                    v-for="(entry, index) in entries"
                    :key="index"
                    class="py-4 px-2"
                >
                    <a
                        class="text-small text-sm"
                        :href="entry.uri"
                    >{{ entry.title }}</a>
                </div>
            </entries>
        </div>
    </footer>
</template>

<script>
import SectionText from "@/components/SectionText";

export default {
    props: ["doc"],

    components: {
        SectionText
    },

    computed: {
        isDark() {
            return (
                ["primary", "secondary"].indexOf(
                    this.doc.footer_background_color
                ) > -1
            );
        },
        textDoc() {
            return {
                alignment: "left",
                elements: this.doc.footer_elements
            };
        },
        footerClass() {
            return {
                primary: "bg-primary inverse",
                secondary: "bg-secondary inverse"
            }[this.doc.footer_background_color];
        }
    },

    methods: {},

    mounted() {}
};
</script>


// WEBPACK FOOTER //
// src/components/SiteFooter.vue